// should only be used inside wrapped fetch when creating clients.

export const updateClientErrorStack = <T extends Error>(
  err: T,
  originalStack: string | undefined
) => {
  const preservedStack = originalStack?.split('\n')
  const [_errName, ...calleeStack] = preservedStack
    ? preservedStack.slice(0, 4)
    : [undefined, undefined]
  const callerStack = preservedStack ? preservedStack.slice(4) : [undefined]
  const modifiedStack = preservedStack
    ? `${callerStack.join('\n')}\n${calleeStack.join('\n')}`
    : undefined

  const [errName, ...restStack] = err.stack?.split('\n') ?? [undefined, '']
  if (modifiedStack && errName) {
    err.stack = `${errName}\n${modifiedStack}\n${restStack.join('\n')}`
  }
  return err
}
